import React, {
  createContext,
  SetStateAction,
  useContext,
  useState,
} from 'react'
import { Bookmark } from 'types'

interface IBookmarkssContext {
  activeBookmark: Bookmark | null
  setActiveBookmark: React.Dispatch<SetStateAction<Bookmark | null>>
  fetchedBookmarks: Bookmark[]
  setFetchedBookmarks: React.Dispatch<SetStateAction<Bookmark[]>>
}

export const BookmarksContext = createContext<IBookmarkssContext>({
  activeBookmark: null,
  setActiveBookmark: () => {},
  fetchedBookmarks: [],
  setFetchedBookmarks: () => {},
})

export function BookmarksProvider({ children }) {
  const [activeBookmark, setActiveBookmark] = useState<Bookmark | null>(null)
  const [fetchedBookmarks, setFetchedBookmarks] = useState<Bookmark[]>([])

  return (
    <BookmarksContext.Provider
      value={
        {
          activeBookmark,
          setActiveBookmark,
          fetchedBookmarks,
          setFetchedBookmarks,
        } as IBookmarkssContext
      }
    >
      {children}
    </BookmarksContext.Provider>
  )
}

export const useReportsCtx = () => {
  return { ...useContext(BookmarksContext) }
}
